import React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import RouteGuard from '../shared/RouteGuard';
import EventsView from './EventsView';

// The /events door. Closed unless the Events pack is on for this organization (capability AND an Events entity);
// anyone else who types the address lands on the dashboard, exactly as for any other module they cannot use.
export default function EventsRoute({ enabled, loading, userId, orgId, isUser }) {
    const navigate = useNavigate();
    if (loading) return <div className="p-8 text-center text-gray-400">Loading…</div>;
    if (!enabled) return <Navigate to="/dashboard" replace />;
    return (
        <RouteGuard module="events" action="view" isUser={isUser}>
            <EventsView userId={userId} orgId={orgId} isUser={isUser} onOpenGuests={(event) => navigate(`/events/${event.engagement_id}/guests`)}
                onOpenPlan={(eventId) => navigate(`/events/${eventId}/plan`)} onOpenPrograms={() => navigate('/events/programs')} />
        </RouteGuard>
    );
}
